export const SET_SCHOLA = 'SET_SCHOLA'

export const setSchola = data => async dispatch => {
  dispatch({
    type: SET_SCHOLA,
    payload: data
  })
}